// Deprecated: This hook is used to provide object type to legacy inputs for

import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useObjectTypeId } from './useObjectTypeId';

// backwards compatibility, it should not be used in new code.
export const useObjectType = () => {
  const objectTypeId = useObjectTypeId();
  return denormalizeTypeId(objectTypeId);
};